import React__default from 'react';
import classnames from 'classnames';
import { SelectionBoxRadio, Price } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/elements';
import { TileLayout } from '@grandvisionhq/fun-products';

const PriceLabel = ({ price  })=>{
    var ref;
    if (!price || !price.value) {
        return null;
    }
    const resolvedPriceCentAmount = (price === null || price === void 0 ? void 0 : (ref = price.discounted) === null || ref === void 0 ? void 0 : ref.value.centAmount) || (price === null || price === void 0 ? void 0 : price.value.centAmount);
    const currencyCode = price === null || price === void 0 ? void 0 : price.value.currencyCode;
    return /*#__PURE__*/ React__default.createElement(Text, {
        variant: "caption"
    }, /*#__PURE__*/ React__default.createElement(Price, {
        value: resolvedPriceCentAmount,
        centAmount: true,
        currency: currencyCode
    }));
};
const OfferingsList = ({ className , offeringItems , selectedValue , onChange ,  })=>{
    return /*#__PURE__*/ React__default.createElement("fieldset", {
        className: classnames('offerings-list', className)
    }, offeringItems.map(({ title , subTitle: subtitle , price , sku , icon  })=>{
        return /*#__PURE__*/ React__default.createElement(SelectionBoxRadio, {
            key: title,
            name: "offerings",
            value: sku,
            checked: selectedValue === sku,
            onChange: ()=>onChange(sku)
        }, /*#__PURE__*/ React__default.createElement(TileLayout, {
            title: title,
            subtitle: subtitle,
            iconName: icon
        }, /*#__PURE__*/ React__default.createElement(PriceLabel, {
            price: price
        })));
    }));
};

export { OfferingsList };
//# sourceMappingURL=OfferingsList.js.map
